<script>
    export default {
        name: 'residencesTable',

        props: {
            data: null,
            headingForCostColumn: null
        }

    }
</script>

<template>
    <div class="a-tableWrapper" >
        <h5>{{ data.name }}</h5>
        <div class="a-tableWrapperSlider">
            <table class="a-table--responsive a-table tf-table" >
                <thead>
                <tr>
                    <th>Residence</th>
                    <th>{{ headingForCostColumn }}</th>
                    <th>New Student Deposit</th>
                    <th>Continuing Student Deposit</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="row in data.costs" :key="row.id" >
                    <td>{{row.name}}</td>
                    <td>{{row.annualCost | toCurrency}}</td>
                    <td>{{row.newStudentDeposit | toCurrency}}</td>
                    <td>{{row.continuingStudentDeposit | toCurrency}}</td>
                </tr>
                </tbody>
            </table>
        </div>
    </div>
</template>
